export enum HHDSCheckboxGroupBehaviour {
  Default = "default",
  Radio = "radio",
}
